module.exports = __webpack_public_path__ + "static/media/on-eye_classic-Bright.35c6d555.jpg";